import React from 'react';
import { string, bool } from 'prop-types';

import Icon from 'components/icon';

const BrandSimpleCard = ({
    bigTitle,
    url,
    topIcon,
    iconName,
    title,
    target
}) => (
    <a className="c-brand-card" href={url} target={target || undefined}>
        {topIcon && (
            <div className="c-brand-card__top-icon">
                <Icon glyph={topIcon} />
            </div>
        )}
        <h3
            className={`c-brand-card__title ${
                bigTitle ? ' c-brand-card__title--big' : ''
            }`}
        >
            {title}
            <Icon glyph={iconName || 'arrow-right'} />
        </h3>
    </a>
);

BrandSimpleCard.propTypes = {
    bigTitle: bool,
    url: string.isRequired,
    topIcon: string,
    iconName: string,
    title: string.isRequired,
    target: string
};

export default BrandSimpleCard;
